export const SET_INTERACTION_STATUS = 'INTERACTION/Status/set';
